import styled from 'styled-components';

export const BookFilght = styled.div`
  &:not(&:last-child) {
    margin-bottom: ${({ theme }) => theme.spacing.x3};
  }
`;

export const BookFilghtCard = styled.div`
  display: flex;
`;

export const BookFilghtDetails = styled.div`
  flex: 1;
  display: flex;
`;
export const BookFilghtDetailsCol = styled.div`
  flex: 1;
`;
export const BookFilghtDetailsTime = styled.div`
  font-weight: 500;
`;

export const BookFilghtDetailsCity = styled.div`
  font-weight: 500;
  font-size: ${({ theme }) => theme.fs.xxs};
  margin-bottom: ${({ theme }) => theme.spacing.x3};
`;
export const BookFilghtDetailsPlane = styled.div`
  color: ${({ theme }) => theme.palette.primary};
  font-weight: 500;
  font-size: ${({ theme }) => theme.fs.xxs};
  line-height: ${({ theme }) => theme.spacing.x4};
`;
export const BookFilghtDetailsCompany = styled.div`
  color: ${({ theme }) => theme.palette.primary};
  font-weight: 500;
  font-size: ${({ theme }) => theme.fs.xxs};
  line-height: ${({ theme }) => theme.spacing.x4};
`;
export const BookFilghtDetailsHourInfo = styled.div`
  color: ${({ theme }) => theme.palette.primary};
  flex: 0.25;
`;
export const BookFilghtDetailsSvg = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.x1};
`;

export const BookFilghtDetailsHour = styled.div`
  line-height: ${({ theme }) => theme.spacing.x4};
  font-size: ${({ theme }) => theme.fs.xxs};
`;
export const BookFilghtDetailsFlight = styled.div`
  line-height: ${({ theme }) => theme.spacing.x4};
  font-size: ${({ theme }) => theme.fs.xxs};
`;

export const BookFilghtCabinClass = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
`;

export const BookFilghtCabinBox = styled.div`
  background: ${({ theme }) => theme.palette.white};
  border: 1.5px solid #c4d6fb;
  box-shadow: 0px 4px 10px rgba(88, 138, 240, 0.15);
  border-radius: ${({ theme }) => theme.rounded.x4};
  padding: ${({ theme }) => theme.spacing.x2};
  width: 184px;
`;

export const BookFilghtCabinName = styled.div`
  color: #a9aebc;

  font-size: ${({ theme }) => theme.fs.xxs};
`;

export const BookFilghtMiles = styled.div`
  font-size: ${({ theme }) => theme.fs.md};
  font-weight: bold;
  margin: ${({ theme }) => theme.spacing.x2} 0;
`;

export const BookFilghtMilesSpan = styled.div`
  font-weight: normal;
  margin-inline-start: ${({ theme }) => theme.spacing.x1};
  font-size: ${({ theme }) => theme.fs.sm};
`;
export const BookFilghtDesc = styled.div`
  color: #a9aebc;
  font-size: ${({ theme }) => theme.fs.xxs};
`;
